import { colors } from 'components/styles/variables';

interface Props {
  className?: string;
  isActive?: boolean;
}

function Bar({ className = '', isActive }: Props): JSX.Element {
  return (
    <div className={`navbar-desktop-bar ${isActive ? 'active' : ''} ${className}`}>
      <style jsx>{`
        .navbar-desktop-bar {
          position: relative;
          height: 3px;
          width: 100%;
          background-color: ${colors.ALR1};
          display: none;
          z-index: 1;
        }
        .active {
          display: block;
        }
      `}</style>
    </div>
  );
}

export default Bar;
